import React from 'react';
import { 
  Box, 
  Button, 
  Typography, 
  Container, 
  Paper,
  AppBar,
  Toolbar,
  IconButton
} from '@mui/material';
import { useAppNavigation } from '../hooks/useAppNavigation';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import PhotoLibraryIcon from '@mui/icons-material/PhotoLibrary';
import AddBoxIcon from '@mui/icons-material/AddBox';

const AddItemBox = () => {
  const navigate = useAppNavigation();
  
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
      {/* App Bar */}
      <AppBar position="static">
        <Toolbar>
          <IconButton
            edge="start"
            color="inherit"
            aria-label="back"
            onClick={() => navigate.to.HOME()}
            sx={{ mr: 2 }}
          >
            <ArrowBackIcon />
          </IconButton>
          <Typography variant="h6" component="div" sx={{ flexGrow: 1, fontWeight: 'bold' }}>
            Add Items or Box
          </Typography>
        </Toolbar>
      </AppBar>
      
      {/* Main Content */}
      <Container component="main" sx={{ 
        flexGrow: 1, 
        display: 'flex', 
        flexDirection: 'column', 
        justifyContent: 'center',
        py: 4
      }}>
        <Paper elevation={0} sx={{ 
          backgroundColor: 'transparent', 
          display: 'flex', 
          flexDirection: 'column', 
          alignItems: 'center',
          gap: 3
        }}>
          {/* Main Action Buttons */}
          <Button
            variant="contained"
            color="primary"
            size="large"
            startIcon={<PhotoLibraryIcon />}
            onClick={() => navigate.to.ADD_ITEM()}
            fullWidth
            sx={{ 
              py: 2.5, 
              borderRadius: 2,
              fontSize: '1.1rem',
              maxWidth: 300
            }}
          >
            Add Items
          </Button>
          
          <Button
            variant="contained"
            color="secondary"
            size="large"
            startIcon={<AddBoxIcon />}
            onClick={() => navigate.to.CREATE_BOX()}
            fullWidth
            sx={{ 
              py: 2.5, 
              borderRadius: 2,
              fontSize: '1.1rem',
              maxWidth: 300
            }}
          >
            Create New Box
          </Button>
        </Paper>
      </Container>
      
      {/* Back to Home Button */}
      <Container sx={{ pb: 3, display: 'flex', justifyContent: 'center' }}>
        <Button
          variant="outlined"
          onClick={() => navigate.to.HOME()}
          sx={{ width: 200 }}
        >
          Back to Home
        </Button>
      </Container>
    </Box>
  );
};

export default AddItemBox;
